import React, { useState } from "react";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import Alert from "../../../components/Alert";
import Button from "../../../components/Button/index";
import Select from "../../../components/Dropdown/index";
import Expire from "../../../components/Expire";
import Loader from "../../../components/Loader";
import apiroutes from "../../../services/apiroutes";
import { requestBooking } from "../../../services/apiservice";
import { getAuth } from "../../../services/auth";

const CorporateSubmitForm = ({ cooperate }) => {
  const history = useHistory();
  const token = getAuth();
  const [year, setYear] = useState("");
  const [maker, setMaker] = useState("");
  const [model, setModel] = useState("");
  const [color, setColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [responseMsg, setResponseMsg] = useState("");
  let cooperatePartner_Details = localStorage.getItem(
    "cooperatePartner_Details"
  );
  cooperatePartner_Details = JSON.parse(cooperatePartner_Details);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setResponseMsg("Processing");
    setLoading(true);
    const cooperatePartnersInformation = {
      Vehicles: [
        {
          Make: maker,
          VehicleMake: year,
          VehicleModel: model,
          Colour: color,
        },
      ],
      Name: cooperatePartner_Details.FirstName + " " + cooperatePartner_Details.LastName,
      FirstName: cooperatePartner_Details.FirstName,
      LastName: cooperatePartner_Details.LastName,
      BusinessName: cooperatePartner_Details.BusinessName,
      CompanyName: cooperatePartner_Details.CompanyName,
      CompanyRcNumber: cooperatePartner_Details.CompanyRcNumber,
      InspectionLocation: cooperatePartner_Details.InspectionLocation,
      BusinessAddress: cooperatePartner_Details.businessAddress,
      PartnerType: cooperatePartner_Details.PartnerType,
      State: cooperatePartner_Details.state,
      PhoneNumber: cooperatePartner_Details.PhoneNo,
      Email: cooperatePartner_Details.Email,
      NumberOfVehicles: cooperatePartner_Details.NumberOfVehicles,
      CountryCodes: "NG",
    };
    //   cooperatePartnersInformation,
    //   "EP INFOOOOOOOOOOOOOOOOOOOOOOOOOOO"
    // );
    // let authDetails = JSON.parse(localStorage.getItem("partnerAuthDetails"));
    // const token = authDetails.access_token;
    requestBooking(
      apiroutes.SavePartnerEnquiry(),
      "post",
      cooperatePartnersInformation,   
      token
    )
      .then((res) => {
        if (res.data.code === 1 || res.data.code === "1") {
          Swal.fire({
            showConfirmButton: false,
            timer: 5000,
            text: `Thanks for your enquiry! We would get back to you within the next 48 hours`,
            icon: "success",
          });
          localStorage.removeItem("cooperatePartner_Details");
          localStorage.removeItem("individualPartner_Details");
          setLoading(false);
          setTimeout(() => {
            history.push("/");
          }, 4000);
        } else {
          setLoading(false);
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `${res.data.shortDescription}`,
            icon: "error",
          });
      }
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          showConfirmButton: false,
          timer: 4000,
          text: `${err.message}`,
          icon: "error",
        });
        setResponseMsg(null);
      });
  };

  const makerOptions = ["JET", "Toyota"];
  const optionMaker = makerOptions.map((x) => ({ label: x, value: x }));
  const modelOptions = ["JET Movers", "Hiace (High Roof)"];
  const optionModel = modelOptions.map((x) => ({ label: x, value: x }));
  const colorOptions = [
    "Silver",
    "Wine",
    "Navy",
    "Blue",
    "White",
    "Black",
    "Champagne",
    "Gold",
  ];
  const optionColor = colorOptions.map((x) => ({ label: x, value: x }));

  let years = [];
  const d = new Date();
  const n = d.getFullYear();
  for (let i = 2013; i <= n; i++) {
    years.push(i);
  }

  const optionYear = years.map((x) => ({ label: x, value: x }));

  const colorStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "1px dotted black",
      color: state.isSelected ? "white" : "black",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "black" : "black",
    }),
  };
  return (
    <div>
      <section>
        <div className="contactform">
          <div className="contactformholder">
            <div className="partnerform">
              <h3 class="backicon" onClick={cooperate}>
                <i class="fa fa-arrow-left"></i>&nbsp; &nbsp;Back
              </h3>
              <h1>Vehicle Details</h1>
              <p>Kindly provide the details below</p>
              <div className="col-12 justify-content-md-center">
                {error && (
                  <Expire delay={5000}>
                    <Alert
                      className="alert text-center alert-danger"
                      text={error}
                    />
                  </Expire>
                )}
                {responseMsg && !error && (
                  <Expire delay={5000}>
                    <Alert
                      className="alert text-center alert-primary"
                      text={responseMsg}
                    />
                  </Expire>
                )}
              </div>
              <div>
                <label htmlFor="state">Select Maker</label>
                <Select
                  value={maker}
                  options={optionMaker}
                  handleChange={(e) => setMaker(e.value)}
                  placeholder="Select Maker"
                  styles={colorStyles}
                />
                <label htmlFor="state">Select Model</label>
                <Select
                  value={model}
                  options={optionModel}
                  handleChange={(e) => setModel(e.value)}
                  placeholder="Select Model"
                  styles={colorStyles}
                />
                <label htmlFor="state">Select Colour</label>
                <Select
                  value={color}
                  options={optionColor}
                  handleChange={(e) => setColor(e.value)}
                  placeholder="Select Color"
                  styles={colorStyles}
                />
                <label htmlFor="state">Select Year</label>
                <Select
                  value={year}
                  options={optionYear}
                  handleChange={(e) => setYear(e.value)}
                  placeholder="Select Year"
                  styles={colorStyles}
                />
                <Button
                  text={
                    loading ? (
                      <div>
                        <Loader dark={false} />{" "}
                      </div>
                    ) : (
                      "Submit"
                    )
                  }
                  btnstyle={{ backgroundColor: "#E21D00", margin: "20px 0px" }}
                  disabled={!(year && color && model && maker)}
                  handleButtonClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CorporateSubmitForm;
